import React from 'react';
import { motion } from 'framer-motion';
import { researchTrace } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpResearch() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-1968" data-mp="ptepoiixn1qe">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16" data-id="element-1969" data-mp="prtzt67kc6yv">
        <motion.div {...fadeUp} className="lg:col-span-5" data-id="element-1970" data-mp="ksr3qb9k9b31">
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight mb-6" data-id="element-1971" data-mp="fwa4akwwvaan">
            Built for scientific research
          </h2>
          <p className="text-xl text-ink-dark/80 leading-relaxed mb-6" data-id="element-1972" data-mp="6uaotx1joe9t">
            SKP helps research teams connect studies, researchers,
            organizations, populations, interventions, outcomes, and
            publications.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1973" data-mp="21822d7mzviaj">
            The same semantic workflow supports terminology management,
            literature discovery, evidence mapping, and expert-reviewed
            knowledge graphs across research domains.
          </p>
        </motion.div>

        <motion.div {...fadeUp} className="lg:col-span-7" data-id="element-1974" data-mp="2rvllku5vpaw4">
          <div className="bg-white border border-line rounded-lg shadow-premium p-8" data-id="element-1975" data-mp="2dvaupr4kjway">
            <p className="text-sm font-medium text-teal mb-2" data-id="element-1976" data-mp="2it3ykdiege82">A team can ask</p>
            <ol className="relative" data-id="element-1977" data-mp="36j6kebvq0ny8">
              {researchTrace.map((row, index) => <li key={row.label} className="relative flex gap-5 pb-6 last:pb-0" data-id="element-1978" data-mp="36lkiktlp6ga0" data-mpi={index}>
                  {index < researchTrace.length - 1 && <span aria-hidden="true" className="absolute left-[5px] top-4 bottom-0 w-px bg-line" data-id="element-1979" data-mp="2wsc19gdru4h0" />}
                  <span className={`relative mt-1.5 w-[11px] h-[11px] rounded-full shrink-0 ${index === researchTrace.length - 1 ? 'bg-navy' : 'bg-white border-2 border-navy-light'}`} data-id="element-1980" data-mp="3phsmnu2z4l3q" />
                  <div data-id="element-1981" data-mp="7yv7gzn5b85f">
                    <p className="text-xs font-semibold text-ink-muted" data-id="element-1982" data-mp="7xamo1qmv3kr">{row.label}</p>
                    <p className="text-lg font-heading font-semibold text-ink-dark" data-id="element-1983" data-mp="3121a6luee55">
                      {row.value}
                    </p>
                  </div>
                </li>)}
            </ol>
            <p className="mt-8 pt-6 border-t border-line text-ink-muted leading-relaxed" data-id="element-1984" data-mp="3p9uwwmc1nht8">
              Conflicting findings remain visible for review rather than being
              flattened into a single unsupported conclusion.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}